import * as React from 'react'
import { useTranslation } from '@core/i18n/i18n'
import SmallBenefits, {
  SmallBenefitsProps,
} from '@original/components/Benefits/SmallBenefits'
import config from '../../../config/config'
import LYSStaticImage from '@core/components/Primitives/LYSStaticImage'
import style from './index.module.less'

const HazetSmallBenefits: React.FC<SmallBenefitsProps> = (props) => {
  const { t } = useTranslation()
  return (
    <>
      <SmallBenefits
        {...props}
        slots={{
          firstBenefitsIcon: () => (
            <div className={style.icon}>
              <LYSStaticImage
                src={config.assets.benefits.deliveryTruck}
                alt={t('benefits.deliveryText')}
                width={40}
                height={30}
              />
            </div>
          ),
          secondBenefitsIcon: () => (
            <div className={style.icon}>
              <LYSStaticImage
                src={config.assets.benefits.support}
                alt={t('benefits.personalAdviceText')}
                width={30}
                height={25}
              />
            </div>
          ),
          thirdBenefitsIcon: () => (
            <div className={style.icon}>
              <LYSStaticImage
                src={config.assets.benefits.checklist}
                alt={t('benefits.orderingText')}
                width={45}
                height={45}
              />
            </div>
          ),
        }}
      />
    </>
  )
}

export default HazetSmallBenefits
